(function () {
  var roots = document.querySelectorAll('[data-urb-hp]');
  if (!roots.length) return;

  function sync() {
    for (var i = 0; i < roots.length; i++) {
      var root = roots[i];
      var top = Math.max(0, Math.round(root.getBoundingClientRect().top + window.scrollY));
      root.style.setProperty('--urb-hp-header', top + 'px');
    }
  }

  sync();
  window.addEventListener('load', sync);
  window.addEventListener('resize', sync, { passive: true });

  if (window.ResizeObserver) {
    var header = document.querySelector('.header-wrapper') || document.querySelector('.section-header');
    if (header) new ResizeObserver(sync).observe(header);
  }
})();
